import { render } from "./TaskRate.vue?vue&type=template&id=a0ada8dc"
import script from "./TaskRate.vue?vue&type=script&lang=js"
export * from "./TaskRate.vue?vue&type=script&lang=js"

import "./TaskRate.vue?vue&type=style&index=0&id=a0ada8dc&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__